/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Next_ButtonInputs */

const en_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const fr_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const de_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const it_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo`)
};

const ru_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий`)
};

const es_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const zh_cn2_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个`)
};

const ja_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次`)
};

const hi_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const pt_pt2_new_project_next_button = /** @type {(inputs: New_Project_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {New_Project_Next_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_next_button = /** @type {((inputs?: New_Project_Next_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Next_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_next_button(inputs)
	if (locale === "de") return de_new_project_next_button(inputs)
	if (locale === "it") return it_new_project_next_button(inputs)
	if (locale === "ru") return ru_new_project_next_button(inputs)
	if (locale === "es") return es_new_project_next_button(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_next_button(inputs)
	if (locale === "ja") return ja_new_project_next_button(inputs)
	if (locale === "hi") return hi_new_project_next_button(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_next_button(inputs)
	return en_new_project_next_button(inputs)
});